import IconArrowForward from 'assets/icons/arrow-forward.svg';
import DogHappy from 'assets/icons/dog-happy.svg';
import Button from 'components/button-new';
import { FormattedMessage } from 'react-intl';

const EmptyCart: React.FC = () => (
  <div className="mt-6 text-center text-sm lg:py-2" data-test="empty-cart">
    <DogHappy className="mx-auto w-16" data-test="dog-happy-icon" />
    <h2 className="mt-6 font-black lg:mt-4" data-test="empty-cart-title empty-cart-message">
      <FormattedMessage id="cart:empty:title" data-test="formatted-message-title" />
    </h2>

    <p className="text-text-light-bg-secondary" data-test="empty-cart-description">
      <FormattedMessage
        id="cart:empty:description-test"
        data-test="formatted-message-description"
      />
    </p>

    <Button
      size="xs"
      href="/futterberater"
      className="mt-3 max-w-fit lg:mt-4"
      data-test="empty-cart-button continue-shopping-button"
    >
      <span className="flex items-center gap-1">
        <span className="shrink-0" data-test="empty-cart-button-text">
          <FormattedMessage id="cart:empty:button" data-test="formatted-message-button" />
        </span>
        <IconArrowForward className="w-2.5" data-test="arrow-forward-icon" />
      </span>
    </Button>
  </div>
);

export default EmptyCart;
